/**
 * Booking-partner marks. The badges and detail views identify Viator and
 * TripAdvisor by their logos, so the co-brand reads as branding instead of a
 * line of text on every card.
 */
export function ViatorMark({ className = "w-4 h-4" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} role="img" aria-label="Viator" focusable="false">
      <rect width="24" height="24" rx="6.5" fill="#16233A" />
      <path
        d="M6.3 6.8 12 17.4l5.7-10.6"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="2.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="18.6" cy="6.4" r="1.9" fill="#00AA6C" />
    </svg>
  );
}

/**
 * Viator's own wordmark, as the booking partner supplies it. Used where the
 * brand should read as the real logo rather than a stand-in mark.
 */
export const VIATOR_LOGO_URL =
  "/partner-marks/viator-white-keyline-v2.png";

export function ViatorLogo({ className = "h-[26px] w-auto" }) {
  return (
    <img
      src={VIATOR_LOGO_URL}
      alt="Viator"
      className={`${className} object-contain drop-shadow-[0_1px_1px_rgba(0,0,0,0.3)]`}
      loading="lazy"
      decoding="async"
    />
  );
}

export function TripAdvisorMark({ className = "w-[17px] h-[13px]" }) {
  return (
    <svg viewBox="0 0 32 24" className={className} role="img" aria-label="TripAdvisor" focusable="false">
      <rect x="0" y="3" width="32" height="21" rx="10.5" fill="#00AA6C" />
      <circle cx="10" cy="12.4" r="6.3" fill="#FFFFFF" />
      <circle cx="22" cy="12.4" r="6.3" fill="#FFFFFF" />
      <circle cx="10" cy="12.4" r="2.9" fill="#111111" />
      <circle cx="22" cy="12.4" r="2.9" fill="#111111" />
      <path d="M16 17.4 18.2 21h-4.4z" fill="#00AA6C" />
    </svg>
  );
}

/** Both marks, used where the partner pair needs to read as one lockup. */
export function PartnerLockup({ className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 ${className}`}
      role="img"
      aria-label="Viator · TripAdvisor"
    >
      <ViatorMark className="w-[15px] h-[15px]" />
      <TripAdvisorMark />
    </span>
  );
}